<template>
  <main>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-10"></div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <md-card class="height-match-parent">
          <md-card-header>
            <div class="md-title-small">【カスタマーサポート】</div>
          </md-card-header>
          <md-card-content>
            <p><span class="label">TEL</span>：03-6240-1229</p>
            <p><span class="label">メール</span>：<a href="mailto:jon-web_info@jon.co.jp">jon-web_info@jon.co.jp</a></p>
            <p><span class="label">受付時間</span>：9:00〜18:00（GW・年末年始を除く）</p>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-100 pl-0">
        <md-card class="height-match-parent">
          <md-card-header>
            <div class="md-title-small">【HPからのお問い合わせ】</div>
          </md-card-header>
          <md-card-content>
            <p>
              <a href="https://www.jon.co.jp/contact/" rel="noopener"
                  target="_blank">お問い合わせフォームへ</a>
            </p>
            <p>
              ※営業時間外のお問い合わせは翌営業日の回答になります。
            </p>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-10"></div>
      <div class="md-layout-item md-size-100"></div>
      <div class="md-layout-item md-size-10"></div>
      <div class="md-layout-item md-size-80 md-small-size-100">
        <md-card>
          <md-card-header>
            <div class="md-title mt-5">【FAQ】</div>
          </md-card-header>
          <md-card-content class="pb-0 d-flex align-items-center justify-content-between">
            <md-field class="md-layout-item md-size-85">
              <label>キーワード</label>
              <md-input name="keyword" v-model="keyword" autofocus v-on:keyup.enter="search"/>
              <div @click="resetSearch">
                <md-icon>cancel</md-icon>
              </div>
            </md-field>
            <div class="md-size-15">
              <md-button class="md-button md-primary md-raised" @click="search">
                <md-icon>search</md-icon> 決定
              </md-button>
            </div>
          </md-card-content>

          <md-card-content>
            <div v-if="filteredCategories.length">
              <faq-category-item v-for="category in filteredCategories" :key="'category-' + category.index"
                                 :category="category"
                                 @clicked="onClickChild"></faq-category-item>
            </div>
            <div v-else>該当する検索結果が見つかりません</div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </main>
</template>

<script>
import CommonMixin          from "@/mixins/commonMixin";
import FaqCategoryItem      from "../../components/frontend/FaqCategoryItem";
import {apiClient, apiList} from "../../modules/apiClient";

export default {
  name      : "Faq",
  mixins    : [CommonMixin],
  components: {
    FaqCategoryItem,
  },
  data      : () => {
    return {
      keyword   : null,
      sending   : false,
      categories: [],
      filteredCategories: [],
    }
  },
  mounted() {
    this.getFaq();
  },
  methods : {
    onClickChild(childCategory) {
      this.filteredCategories.map(category => {
        if (category.id == childCategory.id) {
          category.expanded = childCategory.expanded;
        }
        return category;
      });
    },
    resetSearch() {
      let searchedCategories = this.filteredCategories.map(category => {return {id: category.id, expanded: category.expanded}});
      this.filteredCategories = _.cloneDeep(this.categories);

      if (!this.keyword) {
        this.keyword = null;
        this.filteredCategories.map(category => {
          category.index = 'index-' + category.id + Date.now();
        })
        return null; // just reset by assign this.filteredCategories = this.categories, no more
      }

      // case have keyword
      this.keyword = null;
      this.filteredCategories = this.filteredCategories.map(category => {
        category.index = 'index-' + category.id + Date.now();
        if (searchedCategories.map(item => item.id).includes(category.id)) {
          let filteredCategory = searchedCategories.filter(item => item.id == category.id);
          if (filteredCategory.length) {
            category.expanded = filteredCategory[0].expanded;
          }
        }

        return category;
      });
    },
    search() {
      const keyword = this.keyword;
      this.filteredCategories = _.cloneDeep(this.categories);
      this.filteredCategories = this.filteredCategories
          .filter(category => {
            return keyword === null ||
                keyword === undefined ||
                keyword.length === 0 ||
                category.name.indexOf(keyword) >= 0 ||
                category.faqs.filter(faq => faq.question.indexOf(keyword) >= 0 || faq.answer.indexOf(keyword) >= 0).length
          })
          .map(category => {
            category.filteredFaqs = category.faqs
                .filter(faq => {
                  return keyword === null ||
                      keyword === undefined ||
                      keyword.length === 0 ||
                      category.name.indexOf(keyword) >= 0 ||
                      faq.question.indexOf(keyword) >= 0 || faq.answer.indexOf(keyword) >= 0
                })

            category.filteredFaqs = category.filteredFaqs
                .map(faq => {
                    faq.question = faq.question.replaceAll(keyword, `<span style="background-color: #fafab8;">${keyword}</span>`);
                    faq.answer = faq.answer.replaceAll(keyword, `<span style="background-color: #fafab8;">${keyword}</span>`);
                    return faq;
                });

            category.index = 'index-' + category.id + Date.now();

            return category;
          });
    },
    getFaq() {
      this.sending = true;
      apiClient.get(apiList.faq.list)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.categories = response.data.map(category => {
              category.filteredFaqs = category.faqs.map(faq => faq)
              category.expanded = false;
              category.index = 'index-' + category.id + Date.now();
              return category;
            });
            this.filteredCategories = _.cloneDeep(this.categories);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

.pb-0 {
  padding-bottom: 0;
}

.md-icon {
  font-size: 22px;
}

.mt-5 {
  margin-top: 15px;
}

span.label {
  width: 65px;
  display: inline-block;
}

.height-match-parent {
  height: calc(100% - 15px);
}

.md-title-small {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 32px;
}

.md-card-header {
  padding: 10px 10px 0px;
}

.md-card-content {
  line-height: 12px;
}

.pl-0 {
  @media screen and (min-width: 960px) {
    padding-left: 0 !important;
  }
}
</style>
